module.exports = __webpack_public_path__ + "img/inteligencia-territorial.310ccd7e.svg";